import React from "react";

export const ConnectedIcon = (props: React.SVGAttributes<SVGElement>) => {
  return (
    <svg
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_d_5861_13149)">
        <rect x="7" y="7" width="57" height="57" rx="28.5" fill="#F7F8FA" />
        <rect x="7.5" y="7.5" width="56" height="56" rx="28" stroke="#EBEDF2" />
      </g>
      <path
        d="M46.5548 38.2703C45.7984 38.2703 45.1213 38.6149 44.6724 39.1551L41.853 37.5782C42.0242 37.202 42.1538 36.8012 42.2331 36.3802C42.278 36.1417 42.1207 35.912 41.8818 35.8671C41.6431 35.8225 41.4128 35.9792 41.3679 36.2178C40.9799 38.279 39.1716 39.775 37.0682 39.775C34.6551 39.775 32.6918 37.815 32.6918 35.4058C32.6918 32.9966 34.6551 31.0366 37.0682 31.0366C39.0856 31.0366 40.8324 32.4006 41.316 34.3536C41.3744 34.5892 41.6133 34.733 41.849 34.6748C42.0849 34.6166 42.229 34.3782 42.1706 34.1427C41.8796 32.9678 41.2082 31.9704 40.3061 31.2672L43.3753 26.5835C43.7461 26.7532 44.1578 26.8487 44.5917 26.8487C46.2069 26.8487 47.5209 25.5368 47.5209 23.9243C47.5209 22.3119 46.2069 21 44.5917 21C42.9765 21 41.6625 22.3119 41.6625 23.9243C41.6625 24.7884 42.0402 25.5659 42.6389 26.1017L39.5689 30.7868C38.8205 30.3835 37.9667 30.1577 37.0681 30.1577C35.7412 30.1577 34.5278 30.6512 33.6018 31.4638L29.7824 27.7925C30.2313 27.193 30.4907 26.4535 30.4907 25.6703C30.4907 23.7157 28.8979 22.1255 26.9401 22.1255C24.9824 22.1255 23.3896 23.7157 23.3896 25.6703C23.3896 27.1749 24.3452 28.5196 25.7677 29.0163C25.9973 29.0966 26.2483 28.9757 26.3286 28.7466C26.4088 28.5174 26.2879 28.2668 26.0584 28.1866C24.9886 27.813 24.2699 26.8017 24.2699 25.6702C24.2699 24.2003 25.4677 23.0044 26.9401 23.0044C28.4125 23.0044 29.6104 24.2003 29.6104 25.6702C29.6104 26.8018 28.8916 27.813 27.8218 28.1866C27.5924 28.2667 27.4714 28.5174 27.5517 28.7466C27.6321 28.9762 27.8837 29.0962 28.1125 29.0163C28.5047 28.8793 28.8613 28.6775 29.1723 28.426L32.9911 32.0968C32.2539 33.0003 31.8113 34.1523 31.8113 35.4058C31.8113 35.5768 31.8198 35.7459 31.8359 35.9128L26.7322 36.8431C26.382 35.922 25.4893 35.2654 24.4453 35.2654C23.0969 35.2654 22 36.3606 22 37.7068C22 39.053 23.0969 40.1481 24.4453 40.1481C25.7934 40.1481 26.8902 39.0534 26.8908 37.7077L31.9938 36.7775C32.3424 38.0614 33.1679 39.1515 34.2681 39.8455L32.0301 44.158C31.6487 44.0172 31.2367 43.9401 30.8069 43.9401C28.8572 43.9401 27.2711 45.5236 27.2711 47.47C27.2711 49.4165 28.8572 51 30.8069 51C32.7566 51 34.3427 49.4165 34.3427 47.47C34.3427 46.266 33.7354 45.2013 32.8109 44.5639L35.0491 40.2511C35.6711 40.5104 36.353 40.6538 37.068 40.6538C38.8578 40.6538 40.469 39.7512 41.4226 38.3449L44.2415 39.9214C44.1563 40.1694 44.1093 40.435 44.1093 40.7115C44.1093 42.0577 45.2062 43.1528 46.5547 43.1528C47.9031 43.1528 49 42.0577 49 40.7115C49 39.3653 47.9031 38.2703 46.5548 38.2703ZM42.5429 23.9243C42.5429 22.7965 43.462 21.8789 44.5917 21.8789C45.7214 21.8789 46.6405 22.7965 46.6405 23.9243C46.6405 25.0522 45.7214 25.9698 44.5917 25.9698C43.462 25.9698 42.5429 25.0522 42.5429 23.9243ZM24.4455 39.2693C23.5826 39.2693 22.8805 38.5684 22.8805 37.7069C22.8805 36.8454 23.5826 36.1445 24.4455 36.1445C25.3085 36.1445 26.0106 36.8454 26.0106 37.7069C26.0106 38.5684 25.3085 39.2693 24.4455 39.2693ZM33.4624 47.4701C33.4624 48.9319 32.2712 50.1212 30.807 50.1212C29.3428 50.1212 28.1515 48.9319 28.1515 47.4701C28.1515 46.0084 29.3428 44.8191 30.807 44.8191C32.2712 44.8191 33.4624 46.0084 33.4624 47.4701ZM46.5548 42.274C45.6918 42.274 44.9898 41.5731 44.9898 40.7116C44.9898 39.8501 45.6918 39.1492 46.5548 39.1492C47.4177 39.1492 48.1198 39.8501 48.1198 40.7116C48.1198 41.5731 47.4177 42.274 46.5548 42.274Z"
        fill="#33373D"
      />
      <defs>
        <filter
          id="filter0_d_5861_13149"
          x="0"
          y="0"
          width="71"
          height="71"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="2"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_5861_13149"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.203922 0 0 0 0 0.352941 0 0 0 0 0.47451 0 0 0 0.03 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_5861_13149"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_5861_13149"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
